const RELOAD = "RELOAD";
const SET_APP_INFO = "SET_APP_INFO";
const SET_IS_CART_PAGE = "SET_IS_CART_PAGE";
const SET_EVENT_ID = "SET_EVENT_ID";
const SET_TRAIL_ID = "SET_TRAIL_ID";

export { RELOAD, SET_APP_INFO, SET_IS_CART_PAGE, SET_EVENT_ID, SET_TRAIL_ID };
